import React, { useState, useEffect } from 'react';
import Slider2 from "../components/Slider";
import "./Home.css";
import { Link } from "react-router-dom";

const Home = () => {
    const [showPopup, setShowPopup] = useState(false);
    
    useEffect(() => {
        // Check if the user has already visited the site
        const hasVisited = localStorage.getItem('visited') === 'true';
    
        if (!hasVisited) {
          // If it's the first visit, show the popup
          setShowPopup(true);
    
          // Set a flag in localStorage to indicate the visit
          localStorage.setItem('visited', 'true');
        }
      }, []); // Empty dependency array ensures this effect runs only once on mount
    
    const slides = [
        { 
        id: 1,
        image: "/data/photos/Fantasy/Gallery/Fantasy tmseda01-2560x1440.jpg" ,
        alt: "obrazok"
        },
        { 
            id: 2,
            image: "/data/photos/HomeSlider/home2.jpg",
            alt: "obrazok"
        },
        { 
            id: 3,
            image: "/data/photos/Cosmo/Gallery/COSMO 3-2-2-T V1.jpg",
            alt: "obrazok"
        },
        { 
            id: 4,
            image: "/data/photos/Denver Max/Gallery/Denver blseda latka.jpg",
            alt: "obrazok"
        },
      ];
    
      function determineImageFormat(webpURL, jpgURL) {
        const supportsWebP = (function () {
          const elem = document.createElement('canvas');
      
          if (!elem || !elem.getContext) {
            return false;
          }
      
          return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        })();
      
        return supportsWebP ? webpURL : jpgURL;
    }


    return ( 
        <section className="home-body">
            {showPopup && (
        <div className="popup-container">
          <div className="popup-content">
            <span className="close-btn" onClick={() => setShowPopup(false)}>
              &times;
            </span>
            <h2>Merry Christmas!</h2>
            <p>Wishing you a joyous and festive holiday season!</p>
          </div>
        </div>
      )}
            <div className="sliderContainer">
                <Slider2 slides={slides} />
            </div>
            <div className="about-couches">
                <div className="taylored-couches">
                    <div className="imgline"></div>
                    <h2>Sedačky na mieru</h2>
                    <p>Každý priestor je iný a nie je ľahké nájsť hotovú sedačku, ktorá by mala vhodnú veľkosť a navyše sa vám aj páčila. U nás sme schopní väčšinu sedačiek upraviť podľa vašich požiadaviek. Samozrejmosťou je výber poťahov zo širokej palety vzorkovníkov. V ponuke máme rôzne typy materiálov, farieb a dekorov. Podľa požiadaviek vieme vyrobiť rôzne užitočné doplnky, napr. rozkladacie lôžka, výsuvy, úložné priestory, opierky hlavy pevné aj polohovateľné, vankúše... </p>
                    <Link to={`/Sedacky`} className="more" onClick={window.scrollTo(0,0)}>Viac</Link>
                </div>
                <img src={determineImageFormat("/data/photos/Fantasy/WEBP/FANTASYT.webp", "/data/photos/Fantasy/JPG/FANTASYT.jpg" )} alt="" />
                <div className="stock-couches">
                    <h2>Sedačky skladom</h2>
                    <p>Vážení zákazníci, pozývame Vás do našej predajne Inter-style, ktorá sa nachádza v Ludaniciach časť Mýtna Nová Ves. Po rozšírení predajnej plochy na 3000m2 sme najväčšia predajňa sedačiek na Slovensku s viac ako 300 kusmi ihneď k odberu.</p>
                    <Link to={`/Ihned-k-odberu`} className="more" onClick={window.scrollTo(0,0)}>Viac</Link>
                    <div className="imgline"></div>
                </div>
                <div className="furniture">
                    <h2>Nábytok</h2>
                    <p>Sedačky, stoličky, stoly, sedacie súpravy, rustikálny nábytok, kreslá, pohovky, postele, váľandy, sofa,... Voľba je na Vás!</p>
                    <Link to={`/Nabytok`} className="more" onClick={window.scrollTo(0,0)}>Viac</Link>
                </div>
            </div>
                
            <div className="stats">
                <div className="stats-content">
                <Link to={`/Sedacky`} className="stats-card" onClick={ () => window.scrollTo(0,0)}>
                    <img src="/data/photos/logo/design.png" alt="" />
                        <h3>Sedačky na mieru</h3>
                        <p>Sedacie súpravy na mieru. Slovenský výrobca sedacích súprav s najväčou predajňou sedačiek s okamžitým odberom viac ako 300 druhov.</p>
                    </Link>
                    <Link to={`/Vzorkovniky`} className="stats-card" onClick={ () => window.scrollTo(0,0)}>
                            <img src="/data/photos/logo/fabric.png" alt="" />
                            <h3>Výber z množstva poťahov</h3>
                            <p>Pri návrhu svojej vysnívanej sedacej súpravy Vás nelimituje ani materiál, ani farba. Umožníme vám nájsť správnu kombináciu pre každý interiér.</p>
                    </Link>
                    <Link to={`/Sedacky`} className="stats-card" onClick={ () => window.scrollTo(0,0)}>
                        <img src="/data/photos/logo/production.png" alt="" />
                        <h3>Vlastná výroba</h3>
                        <p>Sedacie súpravy pre Vás vyrábame už 30 rokov. Zamestnávame kvalifikovaných pracovníkov, ktorí sa postarajú o kvalitu Vašej sedačky.</p>
                    </Link>
                    <div class="stats-card">
                        <img src="/data/photos/logo/delivery.png" alt="" />
                        <h3>Dostupná doprava</h3>
                        <p>Sedacie súpravy rozvážame po celom Slovensku i do blízkeho zahraničia za bezkonkurenčné ceny.</p>
                    </div>  
                </div>
                {/*<Link to={`/Onas`} className="moreabout" onClick={window.scrollTo(0,0)}>Viac o nás</Link>*/}
            </div>
            
            <div className="visit-us">
                <h1>Príďte sa pozrieť do jednej z našich predajní</h1>
                <img src="/data/photos/HomeSlider/promo_predajna.jpg" alt="" />
                <Link to={`/Kontakt`} className="contactbtn" onClick={window.scrollTo(0,0)}>Nájdite nás</Link>
            </div>
        </section>
    )
  }
  
  export default Home